export const CREATE_RECIPE75190 = "CREATE_RECIPE75190";
export const UPDATE_RECIPE75190 = "UPDATE_RECIPE75190";
export const DELETE_RECIPE75190 = "DELETE_RECIPE75190";
export const FETCH_RECIPE75190 = "FETCH_RECIPE75190";
export const LISTEN_TO_SELECTED_RECIPE75190 = "LISTEN_TO_SELECTED_RECIPE75190";
